import { createExtension, Injectable, UriHandler, UriHandlers, uriHandlersFactory } from "@snap/camera-kit";

const echoLensUriHandlerFactory = Injectable(
    uriHandlersFactory.token,
    [uriHandlersFactory.token] as const,
    (uriHandlers: UriHandlers) => [...uriHandlers, echoLensUriHandler]
);

const echoLensUriHandler: UriHandler = {
    uri: "echo://test",
    handleRequest(request, reply, lens) {
        const input = new TextDecoder().decode(request.data);
        const output = new TextEncoder().encode(
            `Lens "${lens.name}" sent request "${input}". You see the response from the demo page!`
        );
        reply({
            code: 200,
            description: "",
            contentType: request.contentType,
            data: output,
        });
    },
};

export const echoLensUriExtension = createExtension().provides(echoLensUriHandlerFactory);
